"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setWithRoomNumberWidget = exports.setIsMyHomeWidget = void 0;
var _actionGenerator = require("../../utils/actionGenerator");
var _types = require("./types");
const {
  SET_IS_MY_HOME_WIDGET,
  SET_WITH_ROOM_NUMBER_WIDGET
} = _types.EActionTypes;
const setIsMyHomeWidget = exports.setIsMyHomeWidget = (0, _actionGenerator.actionGenerator)(SET_IS_MY_HOME_WIDGET);
const setWithRoomNumberWidget = exports.setWithRoomNumberWidget = (0, _actionGenerator.actionGenerator)(SET_WITH_ROOM_NUMBER_WIDGET);